import {Component, Inject} from '@angular/core';
import {AcDialog, DIALOG_CONFIG, DialogConfig, SchemaHelperService} from 'ac-infra';
import {TenantsRestService} from "../../services/apis/tenants-rest.service";
import {DevicesRestService} from "../../services/apis/devices-rest.service";
import {LCCustomersRestService} from "../../services/apis/lc-customers-rest.service";
import {ChannelsRestService} from "../../services/apis/channels-rest.service";
import {cloneDeep} from "lodash";

export interface EntitySelectionDialogObject{
    items?: any;
    entity: any;
    selectLabel: string;
    dialogType: string;
    serviceType?: string;
    subRegion?: any;
}

@AcDialog({
    submitButtonText: 'Select',
    cancelButtonText: 'Close',
    overrideSystemViewMode: true,
    width: 450
})
@Component({
    selector: 'entity-selection-dialog',
    templateUrl: './entity-selection-dialog.component.html',
})
export class EntitySelectionDialogComponent {

    entitySelectionObject: EntitySelectionDialogObject = {entity: {}, selectLabel: '', dialogType: ''};
    subRegionalVocaList = [];
    items = [];
    formSettings = {valid: false, touched: false};

    constructor(@Inject(DIALOG_CONFIG) public dialogConfig: DialogConfig,
                private lcCustomersRestService: LCCustomersRestService,
                private tenantsRestService: TenantsRestService,
                private channelsRestService: ChannelsRestService,
                private devicesRestService: DevicesRestService) {}

    ngOnInit() {
        this.items =  cloneDeep(this.dialogConfig.dialogData.items);
        delete this.dialogConfig.dialogData.items; //go to ->  https://gerrit/c/web-ui/ovoc/+/92800
        this.entitySelectionObject =  this.dialogConfig.dialogData;
        this.dialogConfig.formSettings = {valid: true, touched: true};
        this.entityChanged();
    }

    entityChanged() {
        let entity;
        this.subRegionalVocaList = [];

        if(this.entitySelectionObject.dialogType === 'lcCustomer'){
            entity = this.lcCustomersRestService.getEntityById(this.entitySelectionObject.entity.id);
            const channel = entity ? this.channelsRestService.getEntityById(entity.channelId) : undefined;
            this.setSubRegionalVocaList(channel);
        }else if(this.entitySelectionObject.dialogType === 'channel'){
            entity = this.channelsRestService.getEntityById(this.entitySelectionObject.entity.id);
            const tenant = entity ? this.tenantsRestService.getEntityById(entity.tenantId) : undefined;
            this.setSubRegionalVocaList(tenant);
        }else if(this.entitySelectionObject.dialogType === 'tenant'){
            const tenant = this.tenantsRestService.getEntityById(this.entitySelectionObject.entity.id);
            this.setSubRegionalVocaList(tenant);
        }
    }

    setSubRegionalVocaList = (entity) =>{
        if(entity){
            this.subRegionalVocaList = entity?.services?.VOCA?.info?.subRegionalVocaIds?.length > 0 ?
                this.devicesRestService.getAllEntities(entity?.services?.VOCA?.info?.subRegionalVocaIds, true) : [];
        }else{
            this.subRegionalVocaList = [];
        }
    }
}


